/**
 * One rule for how a person's or customer's name looks (KAN-1063, RD-UI-NAMES-001).
 * Pure. Used for DISPLAY and right before a name is SAVED — never for search/filter keys.
 *
 * - null/undefined/'' come back unchanged; emails (any '@') are only trimmed.
 * - Whitespace is trimmed and collapsed to single spaces.
 * - A part (split on `-` and `'`, separators kept) that is ALL lowercase letters gets a capital
 *   first letter; a part with ANY uppercase letter is left as typed ("McDonald", "iCloud", "HOA").
 * - Particles (de, del, la, ...) stay lowercase unless they are the first word.
 */
const PARTICLES = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'da', 'di', 'du', 'van', 'von', 'der', 'and', 'of', 'the']);

const hasLower = (s) => s !== s.toUpperCase();
const hasUpper = (s) => s !== s.toLowerCase();

function capitalizePart(part) {
  if (!part || hasUpper(part) || !hasLower(part)) return part;
  const chars = Array.from(part);
  return chars[0].toUpperCase() + chars.slice(1).join('');
}

function formatWord(word, isFirst) {
  if (!isFirst && PARTICLES.has(word)) return word;
  return word
    .split(/([-'’])/)
    .map((piece) => (/^[-'’]$/.test(piece) ? piece : capitalizePart(piece)))
    .join('');
}

export function formatPersonName(value) {
  if (typeof value !== 'string' || value === '') return value;
  const trimmed = value.trim();
  if (trimmed.includes('@')) return trimmed;
  return trimmed
    .split(/\s+/)
    .map((word, index) => formatWord(word, index === 0))
    .join(' ');
}

export default formatPersonName;
